<style>
.holder {
    background-color: #ebebf3;
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-top: 15px;
}

@media (max-width:972px) {
    .holder {
        width: calc(100% + 20px);
        margin-left: -10px;
    }
}
</style>

<script>
import {afterUpdate} from 'svelte'
import * as Common from './Common.js'
import FeedItemItem from './FeedItems/FeedItemItem.svelte'
import FeedItemComment from './FeedItems/FeedItemComment.svelte'

export let includeNames = false
export let feed = []
export let feedName = ""
export let side
export let displayAreaLabels = false

let areas = []

function setScrollState(id) {
    Common.setCachedFeed(feedName, JSON.stringify({itemId: id, scrollTopValue: side.scrollTop, feed: feed}))
}
</script>

<div class="holder">
{#each feed as m}
    {#if m.type === Common.FEEDTYPE_ITEM}
        <FeedItemItem {displayAreaLabels} {includeNames} item={m.data} {setScrollState}></FeedItemItem>
    {:else if m.type === Common.FEEDTYPE_COMMENT && m.data.content.length != 0}
        <FeedItemComment {displayAreaLabels} {includeNames} comment={m.data} {setScrollState}></FeedItemComment>
    {/if}
{/each}
</div>